
import {defineComponent} from 'vue';
import paycoUtils from "@/assets/js/utils";
import {mapGetters, mapMutations, mapState} from "vuex";
import router from "@/router";
import {NamedRouting} from "@/domain/utils/NamedRouting";
import api from "@/api/backend-api";
import HeaderComponent from "@/components/shared/HeaderComponent.vue";
import store from "@/store";
import Product from "@/domain/product/Product";
import Receiver from "@/domain/receiver/Receiver";
import PopupComponent from "@/components/shared/PopupComponent.vue";
import GetMembershipRequest from "@/domain/request/GetMembershipRequest";
import PostOrderRequest from "@/domain/request/PostOrderRequest";
import Membership from "@/domain/order/Membership";
import ComplexPayment from "@/domain/order/ComplexPayment";

export default defineComponent({
  name: 'productOrderComponent',
  components: {
    PopupComponent,
    HeaderComponent,
  },
  props: [
    'isForPresent'
  ],
  data() {
    return {
      paymentMethod: 'NONE',
      personalInformationConsent: false,
      consentPopup: false,

      usePointUnit: 10,
      minimumRestPointAmount: 1000,
      maximumPointAmount: 9999999,
      minimumPointAmount: 1000,
      pointUseAmountStr: '',

      complexMethod: '',

      showMinimumRestPointAmountPopup: false,
      showMaximumPointAmountToast: false,
      showMinimumPointAmountPopup: false,
      showNoChargeCardPopup: false,

      isDelBtn: false,
      isUseBtn: false,
    }
  },
  mounted() {
    window.vm.productOrderComponent = this;
    this.setOrderPrice(this.product.salePrice * this.sumOfGiftCount);
    if (!this.isNonMemberLogin) {
      api.getComplexPayments()
      .then(response => {
        if (response.data.code === 0) {
          this.complexMethod = response.data.result;
          switch (this.complexMethod) {
            case 'ASP_MEMBERSHIP':
              this.getAspMembership();
              break;
          }
        }
      }).catch(error => { console.log("Error: " + error); });
    }
  },
  computed: {
    ...mapState({
      product: (state: any) => new Product(state.ProductStore.product),
      receivers: (state: any) => state.ReceiverStore.receivers.map((receiver: Receiver) => new Receiver(receiver)),
      message: (state: any) => state.ReceiverStore.message,
    }),
    ...mapGetters('ReceiverStore', [
      'sumOfGiftCount'
    ]),
    ...mapGetters('MemberStore', [
      'isNonMemberLogin'
    ]),
    isDimmedCondition(): boolean {
      return this.consentPopup || this.showMinimumPointAmountPopup
          || this.showMinimumRestPointAmountPopup || this.showNoChargeCardPopup;
    },
    totalPrice(): number {
      return this.orderPrice - this.pointUseAmount - this.chargeCardUseAmount;
    },
    commaTotalPrice(): string {
      return paycoUtils.numWithCommas(this.totalPrice + "");
    },
    canPay(): boolean {
      return (this.paymentMethod != 'NONE' || this.totalPrice == 0) && this.personalInformationConsent;
    },
    orderType(): string {
      return this.isForPresent ? "GIFT" : "PURCHASE";
    },
    ...mapGetters('AppYnStore', [
      'isApp'
    ]),
    commaPointAmount(): string {
      return paycoUtils.numWithCommas(this.pointAmount);
    },
    commaPointUseAmount(): string {
      return paycoUtils.numWithCommas(this.pointUseAmount);
    },
    commaChargeCardAmount(): string {
      return paycoUtils.numWithCommas(this.chargeCardAmount);
    },
    commaChargeCardUseAmount(): string {
      return paycoUtils.numWithCommas(this.chargeCardUseAmount);
    },
    commaMinimumRestPointAmount(): string {
      return paycoUtils.numWithCommas(this.minimumRestPointAmount);
    },
    commaMinimumPointAmount(): string {
      return paycoUtils.numWithCommas(this.minimumPointAmount);
    },
    hasInputPointAmount(): boolean {
      return this.pointUseAmountStr.length > 0;
    },
    ...mapGetters('MembershipStore', [
        'hasChargeCard',
        'isAlreadyAddedCard',
    ]),
    ...mapState('MembershipStore',{
      orderPrice:'orderPrice',
      pointAmount:'pointAmount',
      pointUseAmount:'pointUseAmount',
      chargeCardAmount:'chargeCardAmount',
      chargeCardUseAmount:'chargeCardTotalUseAmount',
      chargeCards:'chargeCards',
    }),
  },
  methods: {
      toggleConsentPopup(): void {
        this.consentPopup = !this.consentPopup;
      },
      toggleMinimumRestPointAmountPopup(): void {
        this.showMinimumRestPointAmountPopup = !this.showMinimumRestPointAmountPopup;
      },
      toggleMinimumPointAmountPopup(): void {
        this.showMinimumPointAmountPopup = !this.showMinimumPointAmountPopup;
      },
      toggleNoChargeCardPopup(): void {
        this.showNoChargeCardPopup = !this.showNoChargeCardPopup;
      },
      initInputStatus(): void {
        this.isDelBtn = false;
        this.isUseBtn = false;
        this.pointUseAmountStr = this.pointUseAmountStr.slice(0,this.pointUseAmountStr.length-1)
      },
      changeNum(str: string): string {
        str = paycoUtils.numRemoveLeftZero(paycoUtils.numWithCommas(paycoUtils.numRemoveCommas(str)));
        return str;
      },
      getUseAmountByMinUnit(point: number): number {
        return Math.floor(point/this.usePointUnit) * this.usePointUnit;
      },

      useMaximumPoint(): void {
        this.isUseBtn = true;
        if (this.pointAmount < this.minimumRestPointAmount) {
          this.showMinimumRestPointAmountPopup = true;
          return;
        }
        if (this.maximumPointAmount > this.totalPrice + this.pointUseAmount) {
          this.setPointUseAmount(this.getUseAmountByMinUnit(this.totalPrice + this.pointUseAmount));
        } else if (this.minimumPointAmount > this.pointAmount) {
          this.showMinimumPointAmountPopup = true;
        } else {
          this.setPointUseAmount(this.getUseAmountByMinUnit(this.pointAmount));
        }
        this.pointUseAmountStr = this.pointUseAmount > 0 ? paycoUtils.numWithCommas(this.pointUseAmount) + '원' : '';
        if (this.totalPrice == 0) {
          this.paymentMethod = 'NONE';
        }
      },
      clearPointUseAmount(): void {
        this.isDelBtn = true;
        this.pointUseAmountStr = '';
        this.setPointUseAmount(0);
      },
      checkPointValidity(): void {
        if (this.pointAmount < this.minimumRestPointAmount) {
          this.setPointUseAmount(0);
          this.pointUseAmountStr = '';
          this.showMinimumRestPointAmountPopup = true;
          return;
        }
        const input = Number(paycoUtils.numRemoveCommas(this.pointUseAmountStr));
        if (input > this.maximumPointAmount || input > this.totalPrice + this.pointUseAmount) {
          if (this.maximumPointAmount < this.totalPrice + this.pointUseAmount) { // 사용 가능 금액 초과(정책)
            this.setPointUseAmount(this.getUseAmountByMinUnit(this.maximumPointAmount));
            this.showMaximumPointAmountToast = true;
            setTimeout(() => {
              this.showMaximumPointAmountToast = false;
            }, 1500);
          } else { // 사용 가능 금액 초과(상품 금액 초과)
            this.setPointUseAmount(this.getUseAmountByMinUnit(this.totalPrice + this.pointUseAmount));
          }
          this.pointUseAmountStr = this.pointUseAmount > 0 ? paycoUtils.numWithCommas(this.pointUseAmount) + '원' : '';
        } else if (input < this.minimumPointAmount && input > 0) { // 최소 사용 금액 미달
          this.setPointUseAmount(0);
          this.pointUseAmountStr = '';
          this.showMinimumPointAmountPopup = true;
        } else if (input == 0) {
          this.setPointUseAmount(0);
          this.pointUseAmountStr = '';
        } else {
          this.setPointUseAmount(this.getUseAmountByMinUnit(input));
          this.pointUseAmountStr = paycoUtils.numWithCommas(this.pointUseAmount) + '원';
        }

        if (this.totalPrice == 0) {
          this.paymentMethod = 'NONE';
        }

        this.isDelBtn = false;
        this.isUseBtn = false;
      },
      checkPointValidityForFocusOut(): void {
        setTimeout(() => {
          if (!this.isDelBtn && !this.isUseBtn) {
            this.checkPointValidity();
          }
        }, 100);
      },
      checkPointValidityForEnterKey(): void {
        setTimeout(() => {
          this.checkPointValidity();
        },100);
      },

      ...mapMutations('MembershipStore', [
        'setOrderPrice',
        'setPointAmount',
        'setPointUseAmount',
        'addChargeCard',
        'clearSelectedChargeCardList',
        'initMembershipStore',
      ]),
      getAspMembership(): void {
        this.pointUseAmountStr = this.pointUseAmount == 0 ? '' : paycoUtils.numWithCommas(this.pointUseAmount);
        const request = new GetMembershipRequest(
          this.product.productId,
          this.product.salePrice,
          this.sumOfGiftCount);
        api.getMembership(request)
          .then(response => {
            if (response.data.code === 0) {
              response.data.result.forEach((membership) => {
                if (membership.accountTypeCode === 'PAY' && membership.restPoint > 0 && !this.isAlreadyAddedCard(membership.cardNo)) {
                  this.addChargeCard(membership);
                } else if (membership.accountTypeCode === 'SAVE') {
                  this.setPointAmount(membership.restPoint);
                  this.minimumPointAmount = Math.max(this.minimumPointAmount, membership.useMinSavePoint!);
                  this.maximumPointAmount = Math.min(this.maximumPointAmount, membership.useMaxSavePoint!);
                  this.minimumRestPointAmount = membership.useAbleMinOwnPoint!;
                  this.usePointUnit = membership.useSavePointUnit!;
                }
              });
              return;
            }

            if (response.data.code === 4444) {
              if (store.getters['AppYnStore/isApp']) {
                router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
              } else {
                if (this.isForPresent) {
                  store.commit('NextViewStore/setNextView', new NamedRouting('ProductOrderForPresent'));
                } else {
                  store.commit('NextViewStore/setNextView', new NamedRouting('ProductOrderForPurchase'));
                }
                router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
              }
              return;
            }
          })
          .catch(error => {
            console.log("Error: " + error);
          });
      },

      orderProduct(): void {
        let complexPayment = {} as ComplexPayment;
        switch (this.complexMethod) {
          case 'ASP_MEMBERSHIP': {
            let points = [];
            this.chargeCards.forEach((chargeCard: Membership) => {
              if (chargeCard.selected) {
                points.push(new Membership(chargeCard));
              }
            });
            if (this.pointUseAmount >= this.minimumPointAmount && this.pointUseAmount <= this.maximumPointAmount
                && this.pointAmount >= this.minimumRestPointAmount && this.pointUseAmount % this.usePointUnit == 0) {
              points.push(new Membership({
                accountTypeCode: "SAVE", usePoint: this.pointUseAmount,
                restPoint: this.pointAmount, cardNo: '', selected: false
              }));
            }
            complexPayment = new ComplexPayment({
              paymentMethod: this.complexMethod,
              paymentAmount: this.pointUseAmount + this.chargeCardUseAmount,
              points: points
            });
            break;
          }
        }

        const request = new PostOrderRequest(
            this.product.productId,
            this.orderPrice,
            this.orderType,
            this.paymentMethod,
            this.message,
            this.receivers,
            this.isApp ? window.location.href : 'javascript:window.close();',
            this.isNonMemberLogin? undefined : complexPayment);

        api.orderProduct(request)
        .then(response => {
          if (response.data.code === 0) {
            if (this.isApp) {
              location.href = response.data.result.orderSheetUrl;
            } else {
              window.open(response.data.result.orderSheetUrl, 'popupPayco', 'top=100, left=300, width=727px, height=512px, resizable=no, scrollbars=yes');
            }
            return;
          }

          alert("결제 요청에 실패했습니다.");
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      moveToPaymentSuccessPage(route: NamedRouting): void {
        router.replace(route);
      },
      goToChargeCardSelectionPage(): void {
        if (this.pointUseAmountStr.charAt(this.pointUseAmountStr.length-1) != '원') {
          this.setPointUseAmount(0);
          this.pointUseAmountStr = '';
        }
        if (this.hasChargeCard) {
          if (this.isForPresent) {
            router.push(new NamedRouting('ChargeCardSelectionForPresent'));
          } else {
            router.push(new NamedRouting('ChargeCardSelectionForPurchase'))
          }
        } else {
          this.showNoChargeCardPopup = true;
        }
      }
    },
})
;

